<template>
  <div>
    <div>
      <LanguagesCard
        v-for="language of peParty.learned_languages"
        :key="language.id"
        :item="language"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <LanguagesCard
        v-for="item of partySurveyCardsByIdentifiers('languages-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Language"
      :has-new-section="peLanguagesCardHasNewSection"
      @on-add="peLanguagesCardAddSection"
    />

    <IncomeCard
      class="mb-4"
      :item="peParty"
    />

    <div v-if="peSurveysValidationActive">
      <IncomeCard
        v-for="item of partySurveyCardsByIdentifiers('income-card')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <div>
      <TravelHistoriesCard
        v-for="travel_history of peParty.travel_histories"
        :key="travel_history.id"
        :item="travel_history"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <TravelHistoriesCard
        v-for="item of partySurveyCardsByIdentifiers('travel-histories-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Travel History"
      :has-new-section="peTravelHistoriesCardHasNewSection"
      @on-add="peTravelHistoriesCardAddSection"
    />

    <div>
      <ImmigrationProceedingsCard
        v-for="immigration_proceeding of peParty.immigration_proceedings"
        :key="immigration_proceeding.id"
        :item="immigration_proceeding"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <ImmigrationProceedingsCard
        v-for="item of partySurveyCardsByIdentifiers('immigration-proceedings-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Immigration Proceeding"
      :has-new-section="peImmigrationProceedingsCardHasNewSection"
      @on-add="peImmigrationProceedingsCardAddSection"
    />

    <div>
      <ImmigrationBenefitsCard
        v-for="immigration_benefit of peParty.immigration_benefits"
        :key="immigration_benefit.id"
        :item="immigration_benefit"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <ImmigrationBenefitsCard
        v-for="item of partySurveyCardsByIdentifiers('immigration-benefits-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Immigration Benefit"
      :has-new-section="peImmigrationBenefitsCardHasNewSection"
      @on-add="peImmigrationBenefitsCardAddSection"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { PARTY_NAMESPACE } from '@/store/party'

import ImmigrationBenefitsCard from './SectionCards/BackgroundCards/ImmigrationBenefitsCard'
import ImmigrationProceedingsCard from './SectionCards/BackgroundCards/ImmigrationProceedingsCard'
import IncomeCard from './SectionCards/BackgroundCards/IncomeCard'
import LanguagesCard from './SectionCards/BackgroundCards/LanguagesCard'
import SectionAdderLine from './SectionTools/SectionAdderLine'
import TravelHistoriesCard from './SectionCards/BackgroundCards/TravelHistoriesCard'

export default {
  name: 'PEBackground',

  components: {
    ImmigrationBenefitsCard,
    ImmigrationProceedingsCard,
    IncomeCard,
    LanguagesCard,
    SectionAdderLine,
    TravelHistoriesCard,
  },

  beforeRouteLeave (_, __, next) {
    if (this.peAnyUnlockedSections) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.peLockPartySections()
        next()
      } else next(false)
    } else {
      this.peLockPartySections()
      next()
    }
  },

  props: {
    id: {
      type: String || Number,
      required: true,
    },
  },

  setup () {
    return { ...alertHandler() }
  },

  computed: {
    ...mapGetters(PARTY_NAMESPACE, [
      'peAnyUnlockedSections',
      'peImmigrationBenefitsCardHasNewSection',
      'peImmigrationProceedingsCardHasNewSection',
      'peLanguagesCardHasNewSection',
      'peParty',
      'peTravelHistoriesCardHasNewSection',
    ]),

    ...mapGetters(PARTY_NAMESPACE, [
      'partySurveyCardsByIdentifiers',
      'peSurveysValidationActive',
    ]),
  },

  created () {
    this.peGetPartySection({ id: this.id }).
      catch(() => this.displayAlert('error', `No Party found with the id: ${this.id}`))
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peGetPartySection',
      'peImmigrationBenefitsCardAddSection',
      'peImmigrationProceedingsCardAddSection',
      'peLanguagesCardAddSection',
      'peLockPartySections',
      'peTravelHistoriesCardAddSection',
    ]),
  },
}
</script>
